/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=19e042ab&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=19e042ab&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e042ab"],['__file',"library/components/VabSearch/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19e042ab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19e042ab', __exports__)) {
    api.reload('19e042ab', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=19e042ab&scoped=true&ts=true", () => {
    api.rerender('19e042ab', render)
  })

}


export default __exports__